import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Tab, Tabs, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { PageLayout } from '@ui/components/PageLayout';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import RelationProfile from './components/RelationProfile';
import RelationOverview from './components/RelationOverview';
import { useRelationDetailStyles } from './useRelationDetailStyles';
import { useRedirectOnCompanyChange } from '@ui/hooks/useRedirectOnCompanyChange';
import { useAppDispatch } from '@application/store/useStore';
import { useSelector } from 'react-redux';
import { getExternalRelationByIdAsync } from '@application/features/externalRelations/externalRelationsThunk';
import { Icon } from '@iconify/react';
import { Profile2User } from 'iconsax-react';
import { useHelpTopic } from '@ui/contexts';
const RELATION_DETAIL_TAB_TOPICS = ['general', 'eventsAttended', 'tags'];
import { isZeroDate } from '@application/utilities/date-utils';
const RelationDetail = () => {
    useRedirectOnCompanyChange('/relations');
    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const styles = useRelationDetailStyles();
    const { selectedCompanyId } = useSelector((state) => state.company);
    const { selectedExternalRelation } = useSelector((state) => state.externalRelations);
    const dispatch = useAppDispatch();
    const [activeTab, setActiveTab] = useState(0);
    useHelpTopic(RELATION_DETAIL_TAB_TOPICS[activeTab]);
    // Placeholder data
    const relation = {
        name: `${selectedExternalRelation?.firstName} ${selectedExternalRelation?.lastName}`,
        designation: selectedExternalRelation?.designation,
        company: selectedExternalRelation?.company,
        email: selectedExternalRelation?.email,
        phoneNo: selectedExternalRelation?.phoneNo,
        dateOfBirth: isZeroDate(selectedExternalRelation?.dob) ? undefined : selectedExternalRelation?.dob,
        referredName: selectedExternalRelation?.personName
    };
    useEffect(() => {
        if (selectedCompanyId && selectedCompanyId.length > 0 && id) {
            dispatch(getExternalRelationByIdAsync(id)).unwrap();
        }
    }, [dispatch, selectedCompanyId, id]);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const handleBackClick = () => {
        navigate('/relations');
    };
    return (_jsx(PageLayout, { title: t('relations.relationDetails') || 'Relation Details', 
        // titleVariant='h2'
        // secondTitle={t<string>('people.accessAndManageAllPeopleRecordsHere')}
        showLeftIcon: true, leftIcon: _jsx(Profile2User, { variant: 'Outline' }), onBackClick: handleBackClick, showBackButton: true, backIcon: _jsx(Icon, { icon: 'eva:arrow-ios-back-outline', width: 24, height: 24, color: theme.palette.common.white }), showBreadCrumbs: true, showTabs: true, tabs: _jsxs(Tabs, { value: activeTab, onChange: handleTabChange, children: [_jsx(Tab, { label: t('people.general') }), _jsx(Tab, { label: t('people.eventsAttended') }), _jsx(Tab, { label: t('settings.tags') })] }), children: _jsx(Box, { sx: styles.container, children: activeTab === 0 ? (
            // General Tab - Show RelationProfile in full width (Grid size 12)
            _jsx(Grid, { container: true, spacing: 2, children: _jsx(Grid, { size: { xs: 12 }, children: _jsx(RelationProfile, { relation: relation }) }) })) : (
            // Other Tabs - Show RelationProfile on left and RelationOverview on right
            _jsx(Grid, { container: true, sx: styles.mainLayout, spacing: 2, children: _jsx(Grid, { size: { xs: 12 }, sx: {
                        ...styles.rightPanel,
                        flexGrow: { lg: 1 },
                        flexBasis: { lg: 0 },
                        minWidth: { lg: 0 }
                    }, children: _jsx(RelationOverview, { relationId: id || '', activeTab: activeTab }) }) })) }) }));
};
export default RelationDetail;
